<template>
  <v-dialog v-model="show" :max-width="600" :fullscreen="$vuetify.breakpoint.xsOnly" transition="dialog-bottom-transition" scrollable>
    <v-card :class="{ 'rounded-xl': !$vuetify.breakpoint.xsOnly }" elevation="10" class="d-flex flex-column">
      <v-card-title class="pa-4 primary white--text d-flex justify-space-between align-center">
        <span class="text-h6 font-weight-bold">Actualizar zona</span>
        <v-btn icon dark @click="show = false" v-if="$vuetify.breakpoint.xsOnly">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6 bg-app">
        <v-container>
          <v-form ref="updateZone">
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="text-subtitle-1 font-weight-bold primary--text">Datos generales</span>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Nombre"
                  :rules="validation()"
                  v-model="name"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Ciudad"
                  v-model="city"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Estado"
                  v-model="state"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Codigo postal"
                  :rules="validation()"
                  type="number"
                  v-model="zipCode"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="Asesor externo en zona(s)"
                  v-model="advisor"
                  :rules="validationEmail()"
                  @keyup.enter="addAdvisor"
                  class="white rounded-lg"
                  append-icon="mdi-email-plus-outline"
                  @click:append="addAdvisor"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-chip
                  v-for="(item, index) in advisorsExternalZone"
                  :key="index"
                  @click:close="removeAdvisor(index)"
                  close
                >
                  {{ item }}
                </v-chip>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4 bg-white">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          text
          @click="show = false"
          :disabled="isLoading"
          class="px-4"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          rounded
          @click="updateZone"
          :loading="isLoading"
          elevation="0"
          class="px-8"
        >
          Actualizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
//validation
import {
  requiredValidation,
  emailValidationIfRequired,
} from "@/helpers/validations.js";
export default {
  data: () => ({
    isLoading: false,
    name: null,
    advisor: null,
    advisorsExternalZone: [],
    city: null,
    state: null,
    zipCode: null,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("zone", ["zoneSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("zone", ["update"]),
    validation(name) {
      return requiredValidation(name);
    },
    validationEmail(name) {
      return emailValidationIfRequired(name);
    },
    async updateZone() {
      try {
        if (this.$refs.updateZone.validate()) {
          this.isLoading = true;
          let payload = {
            zoneId: this.zoneSelected._id,
            zone: {
              name: this.name,
              city: this.city || "",
              state: this.state || "",
              advisors: this.advisorsExternalZone, // internal solena advisors assigned to a personalized area of the client
              zipCode: this.zipCode || "",
            },
          };
          let response = await this.update(payload);
          if (!response) throw response;
          this.$emit("fetchData");
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Zona actualizada",
            timeout: 5000,
          });
          this.show = false;
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al actualizar zona",
          timeout: 5000,
        });
      }
      this.isLoading = false;
    },
    removeAdvisor(index) {
      this.advisorsExternalZone.splice(index, 1);
    },
    validationEmailPattern(email) {
      return /^$|^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(email);
    },
    addAdvisor() {
      if (!this.advisor) return;
      const email = this.advisor.trim();
      if (!this.validationEmailPattern(email)) {
        return;
      }
      this.advisorsExternalZone.push(email);
      this.advisor = null;
    },
    async setZone() {
      // mapping current zone to update
      let zoneCopy = JSON.parse(JSON.stringify(this.zoneSelected));
      this.name = zoneCopy.name;
      this.advisorsExternalZone = zoneCopy.advisors;
      this.city = zoneCopy.city;
      this.state = zoneCopy.state;
      this.zipCode = zoneCopy.zipCode;
    },
  },
  async created() {
    await this.setZone();
  },
};
</script>
